import useApi from '../../../utils/axios-pettitions';
import { setIsAuthenticated } from '../../../contexts/slices/config';
import { clearFilteredOrders, clearOrder, clearSelectedOrders } from '../../../contexts/slices/orders';
import { useAppDispatch } from '../../../contexts/hooks';
import { PermissionsCampus, UserState } from '../../../types/types.user';
import { login as loginRdx, setLoading, putPermissionsCampus, logOut as logOutRdx } from '../../../contexts/slices/auth';
import { setLoadingCnf } from '../../../contexts/slices/config';
import { LoginStruct } from '../../../types/types.user';
import notify from 'devextreme/ui/notify';
import { clearAllNotifications } from '../../../contexts/slices/notifications';
import { clearQuotation } from '../../../contexts/slices/quotations';
import { setDashboards } from '../../../contexts/slices/dashboards';
import { sessionManager } from '../../../utils/session-manager';

const Index = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();

  //Obtener configuración
  const login = async (loginData: LoginStruct) => {
    dispatch(setLoading(true));
    runApi('Authentication/Login', 'POST', null, loginData)
      .then((res) => {
        if (res.internalCode < 200) {
          notify(
            {
              message: res.message,
              type: 'success',
              displayTime: 10000,
              animation: {
                show: {
                  type: 'fade',
                  duration: 400,
                  from: 0,
                  to: 1,
                },
                hide: { type: 'fade', duration: 40, to: 0 },
              },
            },
            {
              position: 'bottom right',
              direction: 'up-stack',
            }
          );
          if (res.internalCode === 102) {
            dispatch(putPermissionsCampus(res.data as PermissionsCampus[]));
          }
          if (res.internalCode === 100) {
            const data: UserState = res.data as UserState;
            dispatch(loginRdx(data));
            dispatch(setIsAuthenticated(true));
            
            // Inicializar el sistema de sesión robusto
            const sessionTimeoutMinutes = 10; // Valor por defecto
            sessionManager.initializeSession(sessionTimeoutMinutes, data.User?.Us_Id?.toString());
          }
          return;
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const logOut = async () => {
    dispatch(setLoadingCnf(true));
    
    try {
      // Primero cerrar sesión en el servidor
      const res = await runApi('Authentication/LogOut', 'POST');
      
      if (res.internalCode < 200) {
        notify(
          {
            message: res.message,
            type: 'success',
            displayTime: 10000,
            animation: {
              show: {
                type: 'fade',
                duration: 400,
                from: 0,
                to: 1,
              },
              hide: { type: 'fade', duration: 40, to: 0 },
            },
          },
          {
            position: 'bottom right',
            direction: 'up-stack',
          }
        );
        
        if (res.internalCode === 103) {
          // Limpiar estado de Redux
          dispatch(logOutRdx());
          dispatch(setIsAuthenticated(false));
          dispatch(clearOrder());
          dispatch(clearQuotation());
          dispatch(clearSelectedOrders());
          dispatch(clearAllNotifications());
          dispatch(setDashboards([]));
          dispatch(clearFilteredOrders());
          
          // Cerrar sesión en el sistema de gestión de sesión
          await sessionManager.logout();
        }
      }
    } catch (error) {
      console.error('Error during logout:', error);
      // Aun si falla el logout en el servidor, limpiar localmente
      dispatch(logOutRdx());
      dispatch(setIsAuthenticated(false));
      dispatch(clearOrder());
      dispatch(clearQuotation());
      dispatch(clearSelectedOrders());
      dispatch(clearAllNotifications());
      dispatch(setDashboards([]));
      dispatch(clearFilteredOrders());
      
      await sessionManager.logout();
    } finally {
      dispatch(setLoadingCnf(false));
    }
  };

  return { login, logOut };
};

export default Index;
